import React from 'react'
import logo from 'assets/images/logo-macro-logistics.png'

function Header() {
  return (
    <header className={`header ml__background--blue`}>
        <div className='header__logo text-center'>
            <img src={logo} alt='Macro Logistics' className='inline-block my-3.5'/>
        </div>
    </header>
  )
}

export default Header